export default __webpack_public_path__ + "static/media/facebook.dac654c6.png";